import { Component, OnInit, ChangeDetectionStrategy, Input,  ChangeDetectorRef } from '@angular/core';
import { DEFAULT_LOADER, LOADER_TYPES } from '@ispm/core/constants/core-ui-constants';
@Component({
  selector: 'gen-overlay-loader',
  templateUrl: './overlay-loader.component.html',
  styleUrls: ['./overlay-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverlayLoaderComponent implements OnInit {
  @Input() showOverlay: boolean = true;

  @Input()
  set loaderType(loaderType: LOADER_TYPES) {
    if (loaderType) {
      this._loaderType = loaderType;
    }

    this.processCss();
  }

  public _loaderType: LOADER_TYPES = DEFAULT_LOADER;
  public isSkeleton: boolean = false;
  public finalClassname: string = ' skeleton ';
  public hideLoader: boolean = false;

  constructor(private detector: ChangeDetectorRef) {  }

  ngOnInit() {
    this.processCss();
  }


  private processCss() {
    if (this._loaderType) {
      if (this._loaderType === 'NONE') {
        this.hideLoader = true;
      } else {
        this.finalClassname = ' skeleton ' + this._loaderType;

        if (this._loaderType === 'CIRCLE') {
          this.finalClassname =  'loader-container ';

          if (this.showOverlay) {
            this.finalClassname = this.finalClassname + ' overlay';
          }
        } else {
          this.isSkeleton = true;
        }
      }
    } else {
      this.finalClassname =  'loader-container ';

      if (this.showOverlay) {
        this.finalClassname = this.finalClassname + ' overlay';
      }
    }

    this.detector.detectChanges();
  }
}
